const DOCS = {
  TAX_SELF_CERTIFICATION: 'tax_self_certification',
  FATCA_FILE: '/files/fatca.pdf',
}

const ICONS = {
  id_card: 'mdi-card-account-details-outline',
  proof_of_address: 'mdi-folder-home-outline',
  proof_of_tax_address: 'mdi-home-variant-outline',
  bank_account_identity: 'mdi-bank-outline',
  tax_self_certification: 'mdi-form-select',
  guardianship_document: 'mdi-file-document-outline',
}

const DOCUMENT_CHECK_STATUSES = {
  isSuccess: 'isSuccess',
  isMissing: 'isMissing',
  isInvalid: 'isInvalid',
}

const DOCUMENT_STATUSES = {
  sent_to_unicia: 'sent_to_unicia',
}

export {
  DOCS, ICONS, DOCUMENT_CHECK_STATUSES, DOCUMENT_STATUSES 
}
